export default __webpack_public_path__ + "static/media/fig2.b8d27ac3.gif";